import { render, staticRenderFns } from "./product-edit.vue?vue&type=template&id=c44240b4&"
import script from "./product-edit.vue?vue&type=script&lang=js&"
export * from "./product-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports